module.exports = __webpack_public_path__ + "img/ic_feature_workout.878872ee.svg";